// Both layouts set `data-turbo="false"`, so Turbo never intercepts these
// submissions and the `data-turbo-confirm` Rails writes is silently ignored —
// every destroy button, and the bulk re-consent send, fired on a single click.
// Rails puts the attribute on the button; check the form too in case it moves.
export function startConfirm() {
  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      const message =
        event.submitter?.getAttribute("data-turbo-confirm") ??
        form.getAttribute("data-turbo-confirm") ??
        form.querySelector("button[data-turbo-confirm]")?.getAttribute("data-turbo-confirm");

      if (message && !window.confirm(message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}
